import React from "react";
import { Link } from "react-router-dom";
import styles from "./EbookCard.module.css";

const EbookCard = ({ book }) => {
  const truncateSummary = (text) => {
    if (!text) return "";
    return text.length > 50 ? `${text.substring(0, 50)}...` : text;
  };


  return (
    <div className={styles.ebookCard}>
      <div className={styles.imageContainer}>
        <img
          src={book.image || "/placeholder-image.jpg"}
          alt={book.title}
          className={styles.coverImage}
        />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.categoryTag}>
          {book.category} | {book.tags && book.tags[0]}
        </div>
        <h2 className={styles.title}>{book.title}</h2>
        <p className={styles.summary}>{truncateSummary(book.summary)}</p>
        <div className={styles.actionButtons}>
          <Link to={`/book/${book.slug}`} className={styles.readNowButton}>
            Read Now
          </Link>
          <Link to={`/book-detail/${book.slug}`} className={styles.detailsButton}>
            Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EbookCard;